import { useEffect, useState } from 'react';
import { collection, doc, onSnapshot, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';
import { useAuth } from '../firebase/useAuth';
import { REACTION_EMOJIS } from '../data/reactions';
import styles from './ReactionBar.module.css';

export default function ReactionBar({ ownerUserId, entryId, categoryKey, accentVar }) {
  const { user } = useAuth();
  const [counts, setCounts] = useState({});
  const [myEmoji, setMyEmoji] = useState(null);

  const reactionDocId = `${user.uid}_${categoryKey}`;
  const reactionRef = doc(db, 'users', ownerUserId, 'entries', entryId, 'reactions', reactionDocId);

  // Subscribe to all reactions for this entry — filter + count client-side
  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, 'users', ownerUserId, 'entries', entryId, 'reactions'),
      (snap) => {
        const newCounts = {};
        snap.docs.forEach(d => {
          const data = d.data();
          if (data.categoryKey !== categoryKey) return;
          newCounts[data.emoji] = (newCounts[data.emoji] || 0) + 1;
        });
        setCounts(newCounts);

        const myDoc = snap.docs.find(d => d.id === reactionDocId);
        setMyEmoji(myDoc ? myDoc.data().emoji : null);
      }
    );
    return () => unsub();
  // eslint-disable-next-line
  }, [ownerUserId, entryId, categoryKey]);

  const handleToggle = async (emoji) => {
    if (myEmoji === emoji) {
      await deleteDoc(reactionRef);
    } else {
      await setDoc(reactionRef, {
        categoryKey,
        emoji,
        authorId: user.uid,
        authorName: user.displayName || user.email || 'Anonymous',
        at: serverTimestamp(),
      });
    }
  };

  return (
    <div className={styles.bar} style={{ '--accent': `var(${accentVar})` }}>
      {REACTION_EMOJIS.map(emoji => {
        const count = counts[emoji] || 0;
        const isActive = myEmoji === emoji;
        return (
          <button
            key={emoji}
            className={`${styles.emoji} ${isActive ? styles.active : ''}`}
            onClick={() => handleToggle(emoji)}
          >
            <span>{emoji}</span>
            {count > 0 && <span className={styles.count}>{count}</span>}
          </button>
        );
      })}
    </div>
  );
}
